import React from 'react';
import PropTypes from 'prop-types';
import { Main } from '../components/Main';
import { withStyles } from '../tools/withStyles';
import { useLanguage } from '../tools/useLanguage';

const styles = () => ({
  root: {
    padding: [40, 20],
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  note: {
    opacity: 0.8
  }
});

const Home = ({ classes }) => {
  const { t } = useLanguage() || {};

  return (
    <Main className={classes.root} noFrame>
      <div className={classes.note}>
        {/* Chat widget loads globally; this page intentionally minimal */}
        <p>{t ? t('home.welcome') : 'Welcome.'}</p>
      </div>
    </Main>
  );
};

Home.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(Home);
